import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b3eb93c")




export default _defineComponent({
  props: {
  name: {
    type: String,
    required: true,
  },
  filled: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

/**
 * AppMaterialIcon Component
 * The component for supporting Material Icons Symbols (new) in the application.
 */


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(_component_q_icon, null, {
    default: _withId(() => [
      _createVNode("span", {
        class: ["material-symbols-outlined custom-material-icon", { 'material-symbols-fill': __props.filled }]
      }, _toDisplayString(__props.name), 3)
    ]),
    _: 1
  }))
}
}

})